<template>
  <div
    class="as_mask"
    v-show="visiable"
    @click.self="maskClose && closeClick()"
    @touchmove.self="e => e.preventDefault()"
  >
    <div
      class="as_bottom"
      :class="{ show: showing }"
      :style="{ paddingBottom: horizenal && 0 }"
    >
      <div class="as_closeIcon" v-show="!noClose" @click="closeClick"></div>
      <div class="as_title">
        <slot name="title"></slot>
      </div>
      <div class="as_content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { overFlowHide, overFlowAuto } from '@/utils';
export default {
  /**
   * show:boolean显示或者隐藏
   * noClose:boolean 是否不需要关闭按钮
   * maskClose:boolean 遮罩层点击关闭
   * closeTag:可设可不设,当页面使用弹窗较多时,如果不想单独处理每个弹窗的关闭逻辑,可设置该属性用于区分
   * 需要确保的是每个弹窗的closeTag值需不同(同样逻辑可使用同一个tag),弹窗关闭后,会把tag值回传给父组件
   * 若无该属性,则返回当前关闭时时间戳
   * eg:
   * bottomAlert: closeTag="1"  @closed="solution"
   * bottomAlert: closeTag="2"  @closed="solution"
   * solution(tag){
   *   switch(tag){
   *     case 1:
   *     //do something
   *     case 2:
   *     //do something
   *   }
   * }
   *
   * 当需要适应不同高度弹窗时,可使用/deep/对.show进行样式覆盖
   * eg:
   * .alertContainer{
   *   /deep/.as_bottom.show{
   *     height: 500px; //将弹窗高度设为500px
   *   }
   * }
   * 使用less样式进行覆盖的原因是使用less会统一进行单位转换,但是直接通过传参将高度传递进来,会有不同设备dpr的适配问题
   */
  props: ['show', 'noClose', 'maskClose', 'closeTag', 'disableScroll'],
  data() {
    return {
      visiable: false,
      showing: false
    };
  },
  computed: {
    horizenal() {
      return 'horizenal' in this.$attrs;
    }
  },
  created() {
    //初始化
    this.visiable = this.show;
    this.showing = this.show;
  },
  watch: {
    show(n) {
      if (n) {
        this.visiable = true;
        //延时为了保证当dom的display不为none之后执行动画,
        //按一般情况来说setTimeout使用最小值,或者将赋值语句放入this.$nextTick即可,
        //但是发现一个bug,当页面中存在animation动画时,以上方法会失效
        //个人感觉是由于dom变化较多于是MutationObserver等页面监听方案会收集一段时间的变化然后一起做处理
        //所以下面使用增加延时时长的方案后减轻了animation的影响
        setTimeout(() => (this.showing = true), 20);
        //overLowHide会影响布局,原因不明,延时调用可以解决该问题
        //该方案十分耗费页面性能,会使整个页面重绘,默认关闭,弹窗状态多的活动最好不要开启
        this.disableScroll &&
          setTimeout(() => {
            //获取body位置,在弹窗出现时定位到具体位置
            let bodyPosition = document.body.getBoundingClientRect();
            let top = bodyPosition.top + 'px';
            document.body.style.top = top;
            //禁止外层滚动
            overFlowHide();
          }, 50);
      } else {
        this.disableScroll &&
          this.$nextTick(() => {
            overFlowAuto();
            //获取弹窗被打开前的top值,使用scrollTo方法在弹窗关闭后定位到具体位置
            let scrollTop = -document.body.style.top.replace('px', '');
            document.body.style.top = ''; //重制为默认值
            window.scrollTo(0, scrollTop);
          });
        this.showing = false; //动画
        setTimeout(() => {
          this.visiable = false; //隐藏
          this.closed(); //关闭完成后的回调
        }, 500);
      }
    }
  },
  methods: {
    /**
     * 父组件中:
     * @close 处理关闭相关的事件
     * @closed 关闭动画结束后的回调
     */
    closeClick() {
      this.$emit('close');
    },
    closed() {
      this.$emit('closed', this.closeTag || Date.now());
    }
  }
};
</script>

<style lang="less" scoped>
.as_mask {
  position: fixed;
  z-index: 10;
  width: 100%;
  height: 100%;
  padding-bottom: 0; //适配iPhoneX
  padding-bottom: constant(safe-area-inset-bottom); //适配iPhoneX
  padding-bottom: env(safe-area-inset-bottom); //适配iPhoneX
  background-color: rgba(0, 0, 0, 0.7);
  top: 0;
  left: 0;

  .as_bottom {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    z-index: 10;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    transform: translateY(1000px);
    padding: 98px 0;
    box-sizing: border-box;
    width: 742px;
    height: 820px;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 40px 40px 0px 0px;
    transition: all 0.5s;

    &.show {
      transform: translateY(0px);
    }

    .as_closeIcon {
      position: absolute;
      z-index: 10;
      top: 20px;
      right: 30px;
      width: 48px;
      height: 48px;
      background-color: rgba(191, 191, 191, 1);
      background-image: url(../assets/common/closeicon.png);
      background-size: 24px 24px;
      background-position: center;
      background-repeat: no-repeat;
      border-radius: 50%;
    }

    .as_title {
      position: absolute;
      top: 0;
      width: 100%;
      height: 98px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .as_content {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      left: 0;
      width: 100%;
      height: 100%;
      overflow-y: auto;

      * {
        flex-shrink: 0;
      }
    }
  }
}
</style>
